import { type ReactElement, useEffect, useMemo } from "react";
import type { ToolboxSectionProps, UseToolboxProps } from "./Toolbox.types";
import { getValidChildren } from "./Toolbox.utils";

export const useToolbox = ({
  children,
  initialValue,
  selected,
}: UseToolboxProps) => {
  const validChildren = useMemo(
    () => getValidChildren(children) as ReactElement<ToolboxSectionProps>[],
    [children]
  );

  useEffect(() => {
    const child = validChildren.find(
      (button) => button.props.value === selected
    )?.props;

    !child?.children && child?.onClick?.();
  }, [selected, validChildren, initialValue]);

  return {
    validChildren,
  };
};
